module.exports = __webpack_public_path__ + "static/media/andrew_portrait.e8853171.png";